import { Text, ActivityItem, DetailsRow, GroupedList, GroupHeader, IActivityItemProps, IActivityItemStyles, IColumn, IconButton, IDetailsRowStyles, IGroup, IGroupHeaderProps, IGroupRenderProps, IIconProps, mergeStyleSets, SelectionMode, TooltipHost, Tooltip, Shimmer } from '@fluentui/react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';
import axios, { CancelTokenSource } from 'axios';
import * as React from 'react';
import { useEffect, useState } from 'react';
import { connect, ConnectedProps, useSelector } from 'react-redux';
import pecmailService from '../../../../../services/pecmail.service';
import protocolDispatchesService from '../../../../../services/protocolDispatches.service';
import { ProtocolDispatchEF_Status, ProtocolDispatchEF_Status_Label } from '../../../../../shared/enums';
import { IMailPecMail, IProtocol, IProtocolDispatch, IRicevuta, IStatoInvio } from '../../../../../shared/interfaces';
import Utilities from '../../../../../shared/Utilities/utilities';
import { RootState } from '../../../../../store';
import { toastRef } from '../../../../Layout/Layout';
import CircleLoader from '../../../../Loader/CircleLoader/CircleLoader';

const downloadIcon: IIconProps = { iconName: 'Download' };

let classNames = mergeStyleSets({
    padding: {
        paddingBottom: '3px',
        paddingTop: '3px'
    },
    headerMargins: {
        marginTop: '20px'
    },
    columnWidth: {
        width: '200px'
    },
    overflow: {
        display: 'block',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    },
    statoLabel: {
        marginRight: '4px',
        fontWeight: 'bold'
    },
    statoColorRed: {
        color: "rgb(232, 12, 12)"
    },
    statoColorGreen: {
        color: "rgb(79, 173, 60)"
    },
    statoColorYellow: {
        color: "rgb(213 163 12)"
    }

});

const activityItemStyles: IActivityItemStyles = {
    root: {
        overflow: 'hidden'
    },
    activityContent: {
        overflow: 'hidden'
    },
    activityText: {
        overflow: 'hidden'
    },
    timeStamp: {
        overflow: 'hidden'
    }
}

const detailsRowStyles: Partial<IDetailsRowStyles> = {
    root: {
        display: 'flex',
        width: '100%',
        flex: 1,

        '& .ms-DetailsRow-fields': {
            width: '100%'
        },
        '& .ms-DetailsRow-cell:first-child': {
            flex: '1 1 auto'
        },
        '& .ms-DetailsRow-cell:nth-child(2)': {
            flex: '0 0 auto'
        }
    }
}

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
    currentUor: state.sessionReducer.currentUor,
    currentUser: state.sessionReducer.currentUser,
})
const mapDispatch = {
}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface SpedizioniProps {
    protocol: IProtocol
    forceSpedizioniRefresh: boolean

}
type Props = SpedizioniProps & PropsFromRedux

export interface SpedizioniState {
    loading: boolean
    loadingSpedizione: number
    spedizioniGroupedList: { spedizioneId: number, items: any[], groups: IGroup[] }[]
    columns: IColumn[]
    groupProps: IGroupRenderProps
}

class Spedizioni extends React.Component<Props, SpedizioniState> {

    cancelTokenSources = {};

    state: SpedizioniState = {
        loading: false,
        loadingSpedizione: 0,
        spedizioniGroupedList: [],
        columns: [

            {
                key: "info",
                name: "Destinatari",
                fieldName: "info",
                minWidth: 300,
                onRender: (item) => this.renderDestinatarioStatoData(item)
            },
            {
                key: "download",
                name: "Download",
                fieldName: "download",
                minWidth: 300,
                onRender: (item) => this.renderDownloadIcon(item)
            }],
        groupProps: {
            isAllGroupsCollapsed: true,
            onRenderHeader: (props?: IGroupHeaderProps): JSX.Element => {

                const toggleCollapse = (): void => {
                    let spedizione = props?.group?.data as IProtocolDispatch;
                    if (props?.group?.isCollapsed) {
                        if (this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name] === undefined) {
                            this.getMailAndStati(spedizione);
                            props!.onToggleCollapse!(props!.group!);
                        }
                    } else if (!props?.group?.isCollapsed) {
                        this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name]?.cancel("Request annullata");

                        props!.onToggleCollapse!(props!.group!);
                    }

                };
                return (
                    <GroupHeader
                        onRenderTitle={this.onRenderTitle}
                        expandButtonProps={{
                            onClick: toggleCollapse
                        }}
                        {...props}
                        className={`${classNames.padding} ${classNames.headerMargins}`} />
                )
            }
        }
    }

    componentDidMount() {
        if (this.props.currentAoo && this.props.protocol) {
            this.getSpedizioni();
        }
    }

    componentDidUpdate(oldProps: Props) {
        if (oldProps.forceSpedizioniRefresh !== this.props.forceSpedizioniRefresh
            || oldProps.currentAoo?.id !== this.props.currentAoo?.id
            || oldProps.protocol !== this.props.protocol) {
            if (this.props.currentAoo && this.props.protocol) {
                this.getSpedizioni();
            }
        }
    }
    componentWillUnmount = () => {
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
    }

    onRenderTitle = (props?: IGroupHeaderProps): JSX.Element => {

        let spedizione = props?.group?.data as IProtocolDispatch;

        let statoRicevutaIconProp: FontAwesomeIconProps | undefined = undefined;

        switch (spedizione.status) {
            case ProtocolDispatchEF_Status.Completata:
                statoRicevutaIconProp = {
                    className: classNames.statoColorGreen,
                    icon: { prefix: 'fas', iconName: 'circle-check' },
                    style: { marginRight: "5px" }
                }
                break;
            case ProtocolDispatchEF_Status.Undefined:
            case ProtocolDispatchEF_Status.DaInviare:
            case ProtocolDispatchEF_Status.InAttesa:
                statoRicevutaIconProp = {
                    className: classNames.statoColorYellow,
                    icon: { prefix: 'fas', iconName: 'clock' },
                    style: { marginRight: "5px" }
                }
                break;
            case ProtocolDispatchEF_Status.Errore:
            case ProtocolDispatchEF_Status.NonAccettata:
            case ProtocolDispatchEF_Status.CompletataConErrori:
                statoRicevutaIconProp = {
                    className: classNames.statoColorRed,
                    icon: { prefix: 'fas', iconName: 'circle-exclamation' },
                    style: { marginRight: "5px" }
                }
                break;

        }
        const item: IActivityItemProps = {
            styles: activityItemStyles,
            activityDescription: [
                //<div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center' }}>
                <div className={`flex  align-items-center justify-content-start`}>

                    <TooltipHost content={`${ProtocolDispatchEF_Status_Label.get(spedizione.status)}`}>
                        <FontAwesomeIcon {...statoRicevutaIconProp} />
                    </TooltipHost>
                    <span className={classNames.overflow}>
                        <TooltipHost content={spedizione.to}>
                            <span key={"mailbox_" + spedizione.id} style={{ fontWeight: "bold" }}>{spedizione.to}</span>
                        </TooltipHost>
                    </span>
                </div>
            ],
            timeStamp: [
                <div className={classNames.overflow}>
                    <TooltipHost content={spedizione.subject}>
                        <span key={"oggetto_" + spedizione.id}>{spedizione.subject} - </span>
                    </TooltipHost>
                    <TooltipHost content={Utilities.FormatDate(spedizione.date, false)}>
                        <span key={"data_" + spedizione.id}>{Utilities.FormatDate(spedizione.date, false)}</span>
                    </TooltipHost>
                </div>
            ]
        }
        return (
            <ActivityItem {...item} />
        )
    }



    // metodi per ottenere tutte le spedizioni
    getSpedizioni = () => {
        this.setState({ loading: true });
        protocolDispatchesService.getProtocolDispatches(this.props.currentAoo!.id, this.props.protocol.id!, this.props.currentUor?.id)
            .then(response => {
                let spedizioniList = this.remapSpedizioni(response);
                this.setState({ loading: false, spedizioniGroupedList: spedizioniList });
            })
            .catch(error => {
                if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: "Attenzione",
                        detail: 'Non è stato possibile recuperare le spedizioni',
                        life: 5000
                    });
                }
            })

    }

    remapSpedizioni = (response: IProtocolDispatch[]) => {

        let mapping = response.map(
            (spedizione) => {
                return {
                    spedizioneId: spedizione.id,
                    items: [
                        {
                            placeholder: "Nessuna ricevuta ancora dispondibile",
                            spedizioneId: spedizione.id,

                        }
                    ],
                    groups: [
                        {
                            key: spedizione.id.toString(),
                            name: "Group Root",
                            startIndex: 0,
                            count: 1,
                            data: spedizione,
                            level: 0,
                            isCollapsed: true

                        } as IGroup]
                }
            }
        );

        return mapping;
    }


    // metodi per ottenere gli stati della mail
    getMailAndStati = (spedizione: IProtocolDispatch) => {
        let newSpedizioneGroupedList = [...this.state.spedizioniGroupedList];
        // trovo l'indice della spedizione da aggiornare con sottogruppi
        let newSpedizioneIndex = newSpedizioneGroupedList.findIndex(s => s.spedizioneId === spedizione.id);
        let newSpedizione = newSpedizioneGroupedList[newSpedizioneIndex];
        newSpedizione!.items = [{
            placeholder: "Nessuna ricevuta ancora dispondibile",
            spedizioneId: spedizione.id,

        }];
        newSpedizioneGroupedList[newSpedizioneIndex] = { ...newSpedizione };
        this.setState({ loadingSpedizione: spedizione.id, spedizioniGroupedList: newSpedizioneGroupedList });
        this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name] = axios.CancelToken.source();

        pecmailService.getMailAndStatiInvioByPecMailId(this.props.currentAoo!.id, this.props.currentUor?.id!, spedizione.mailbox, spedizione.pecMailId, false, this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name].token)
            .then(response => {
                let stati = this.remapStati(response, spedizione.mailbox, spedizione.id);
                if (stati.length > 0) {
                    //copio la lista di spedizioni
                    let newSpedizioneGroupedList = [... this.state.spedizioniGroupedList];
                    // trovo l'indice della spedizione da aggiornare con sottogruppi
                    let newSpedizioneIndex = newSpedizioneGroupedList.findIndex(s => s.spedizioneId === spedizione.id);
                    let newSpedizione = newSpedizioneGroupedList[newSpedizioneIndex];

                    //ordino e assegno gli stati agli items della spedizione
                    let orederedStati = stati.sort((a, b) => {
                        if (a.tipoDestinatario === "certificato") {
                            return -1;
                        } else if (b.tipoDestinatario === "certificato") {
                            return 1;
                        } else {
                            return 0;
                        }
                    });
                    newSpedizione!.items = orederedStati;
                    let group = { ...newSpedizione.groups[0] }
                    group = { ...group, count: stati.length };
                    newSpedizione.groups[0] = group;
                    newSpedizioneGroupedList[newSpedizioneIndex] = { ...newSpedizione };
                    //aggiorno lo stato
                    this.setState({ loadingSpedizione: 0, spedizioniGroupedList: newSpedizioneGroupedList });
                }
                else {
                    this.setState({ loadingSpedizione: 0 });
                }
                delete this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name];

            })
            .catch(error => {
                if (axios.isCancel(error)) {
                    //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                    console.log(error.message);
                }
                else if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: "Attenzione",
                        detail: 'Non è stato possibile recuperare gli stati di invio',
                        life: 5000
                    });
                }
                this.setState({ loadingSpedizione: 0 });
                delete this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name];

            })
    }

    remapStati = (response: IMailPecMail, mailbox: string, spedizioneId: number) => {
        let mapping = response.statiInvio.map(
            (statoInvio) => {
                return {
                    to: statoInvio.destinatario,
                    when: Utilities.FormatDate(statoInvio.dataRicevuta, false),
                    tipoDestinatario: statoInvio.tipoDestinatario,
                    stato: statoInvio.stato.charAt(0).toUpperCase() + statoInvio.stato.slice(1).toLowerCase(),
                    ricevuta: statoInvio.ricevuta,
                    mailbox: mailbox,
                    spedizioneId: spedizioneId
                }
            }
        );
        return mapping;
    }

    // metodi per onRender colonne
    renderDestinatarioStatoData = (item: any) => {
        let statoColorCss = classNames.statoLabel;
        switch (item.stato) {
            case "Consegna":
            case "Accettato":
                statoColorCss += ` ${classNames.statoColorGreen}`;
                break;
            case "In attesa":
                statoColorCss += ` ${classNames.statoColorYellow}`;
                break;
            default:
                statoColorCss += ` ${classNames.statoColorRed}`;
                break;

        }
        if (item.spedizioneId === this.state.loadingSpedizione) {
            return (
                <Shimmer />
            )
        }
        else if (item.placeholder) {
            return (
                <TooltipHost content={item.placeholder}>
                    <div className={classNames.overflow}>{item.placeholder}</div>
                </TooltipHost>
            )
        } else {
            return (
                <>
                    <TooltipHost content={item.to}>
                        <div className={classNames.overflow}>{item.to}</div>
                    </TooltipHost>
                    <TooltipHost content={`${item.stato} in data ${item.when}`}>
                        <span className={classNames.overflow}>
                            <span className={statoColorCss} >{item.stato}</span> in data {item.when}
                        </span>
                    </TooltipHost>
                </>
            );
        }
    }

    renderDownloadIcon = (item: any) => {
        return (
            <>
                {item.ricevuta &&
                    <span>
                        <TooltipHost content="Download File" >
                            <IconButton
                                iconProps={downloadIcon}
                                aria-label="Download"
                                onClick={() => this.downloadFile(item.mailbox, item.ricevuta)}
                            />
                        </TooltipHost>
                    </span>
                }
            </>
        );
    }

    // gestione render delle celle 
    onRenderCell = (nestingDepth?: number, item?: any, itemIndex?: number, group?: IGroup): React.ReactNode => {

        return (
            <DetailsRow
                columns={this.state.columns}
                groupNestingDepth={nestingDepth}
                item={item}
                itemIndex={itemIndex!}
                selectionMode={SelectionMode.none}
                group={group}
                styles={detailsRowStyles}
            />
        );

    }

    //metodo per scaricale il file 
    downloadFile = (mailbox: string, ricevuta: IRicevuta) => {
        toastRef.current?.show({
            severity: 'info',
            summary: "Informazione",
            detail: 'Download in corso',
            life: 5000
        });

        pecmailService.getBase64FromUrl(this.props.currentAoo!.id, this.props.currentUor?.id!, mailbox, ricevuta.urlFile)
            .then(response => {
                Utilities.SaveFileFromBase64(response, ricevuta.nomeFile);
                toastRef.current?.show({
                    severity: 'info',
                    summary: "Informazione",
                    detail: 'Download completato',
                    life: 5000
                });

            })
            .catch(error => {
                 if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: "Attenzione",
                        detail: 'Non è stato possibile scaricare la ricevuta',
                        life: 5000
                    });
                }
                this.setState({ loadingSpedizione: 0 });
                delete this.cancelTokenSources[pecmailService.getMailAndStatiInvioByPecMailId.name];

            })
    }

    render() {
        return (
            <div className={`flex flex-column position-relative`}>
                <CircleLoader loaderClass='loader-large' loading={this.state.loading} />
                <div className={'my-scroll-div position-relative'}>
                    <div className={`my-component-content`}>

                        {this.state.spedizioniGroupedList.length > 0 ?
                            this.state.spedizioniGroupedList.map(
                                (spedizione, index) => (

                                    <GroupedList
                                        key={"spedizione_" + spedizione.spedizioneId}
                                        items={spedizione.items}
                                        onRenderCell={this.onRenderCell}
                                        selectionMode={SelectionMode.none}
                                        groups={spedizione.groups}
                                        groupProps={this.state.groupProps}

                                    />
                                )
                            ) :
                            <div style={{ marginLeft: '31px' }}>
                                <Text> Non ci sono spedizioni </Text>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default connector(Spedizioni);
